import AbstractValidator from './AbstractValidator';
import Domain from './Hostname';

const allowedLocalPartText = 'a-zA-Z0-9\\x21\\x23\\x24\\x25\\x26\\x27\\x2a\\x2b\\x2d\\x2f\\x3d\\x3f\\x5e\\x5f\\x60\\x7b\\x7c\\x7d\\x7e';
const allowedInternationalizedLocalPartText = 'a-zA-Z0-9\\x21\\x23\\x24\\x25\\x26\\x27\\x2a\\x2b\\x2d\\x2f\\x3d\\x3f\\x5e\\x5f\\x60\\x7b\\x7c\\x7d\\x7e';

export default class EmailAddress extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        emailAddressInvalid: 'Die Eingabe ist ungültig, es wird ein Text erwartet',
        emailAddressInvalidFormat: 'Der Eingabewert ist keine gültige E-Mail-Adresse, benutzen Sie folgendes Format: ihr-name@anbieter',
        emailAddressLengthExceeded: 'Der Eingabewert ist länger als erlaubt',
    };

    run()
    {
        if ('string' !== typeof this.value)
        {
            this.error = this.getMessage('emailAddressInvalid');
            return;
        }

        let matches = this.value.match(/^(.+)@([^@]+)$/);

        if(-1 !== this.value.indexOf('..') || !matches)
        {
            this.error = this.getMessage('emailAddressInvalidFormat');
            return;
        }

        let localPart = matches[1];
        let hostname  = matches[2];

        if(this._options && this._options.strict && (localPart.length > 64 || hostname.length > 255))
        {
            this.error = this.getMessage('emailAddressLengthExceeded');
            return;
        }

        if(this._options && this._options.useDomainCheck && !this.validateHostnamePart(hostname))
        {
            return;
        }

        if(
            !localPart.match(new RegExp(`^[${allowedLocalPartText}]+(\\x2e+[${allowedLocalPartText}]+)*$`))
            &&
            !this.validateInternationalizedLocalPart(localPart)
            &&
            !localPart.match(/^"([\x20-\x21\x23-\x5b\x5d-\x7e]|\x5c[\x20-\x7e])*"$/)
        )
        {
            this.error = this.getMessage('emailAddressInvalidFormat');
        }
    }

    validateHostnamePart(hostname: string): boolean
    {
        const Validator = new Domain(hostname, this._options);
        Validator.run();

        this.error = Validator.error;

        return !!Validator.error;
    }

    validateInternationalizedLocalPart(localPart: string): boolean
    {
        return !!localPart.match(new RegExp(`^[${allowedInternationalizedLocalPartText}]+(\\x2e+[${allowedInternationalizedLocalPartText}]+)*$`, 'u'))
    }
}